module.exports = __webpack_public_path__ + "static/media/featured-1.59f1ecbd.jpg";